export default {"src":"/betting-resources/_next/static/media/pinnacle-logo.9e9de32e.svg","height":24,"width":98,"blurWidth":0,"blurHeight":0};